import { useMutation } from '@tanstack/react-query';

import { getSMPBackendAPIAdmin } from '@/proxy';

function deleteLocation(id: string) {
  return getSMPBackendAPIAdmin().locationsControllerDeleteV1(id);
}

export function useDeleteLocation() {
  return useMutation({ mutationFn: deleteLocation });
}
